var ColumnsViewController = (function () {
    function ColumnsViewController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin, Dialog, notify, settings) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.Dialog = Dialog;
        this.notify = notify;
        this.settings = settings;
        this.table = { headersNames: [], dataNames: [], headersOrder: [], dataOrder: [], filter: false, filterParams: {} };
        this.programs = [];
        this.programsLoaded = false;
        this.dataLoaded = false;
        this.table.headerNames = [
            { header: 'Search type' },
            { header: 'Data Source' },
            { header: 'Main' },
            { header: 'Secondary' }
        ];
        //this.logsColumnHeaders = ['Program', 'Action', 'Time', 'User', 'IOTs'];
        this.socket.forward('admin.program_columns_view', this.$scope);
        this.$scope.$on('socket:admin.program_columns_view', function (event, data) {
            if (data.action === 'logs-group') {
                if (data.success) {
                    if (angular.isDefined(data)) {
                        _this.table.dataNames = _this.adjustColumnNamesLayout(data.dataUpdated.all_column_order);
                        _this.table.dataOrder = data.all_column_order;
                    }
                }
                else {
                    _this.notify.error(data.msg);
                }
            }
            else if (data.action === 'single-log') {
                if (data.success) {
                    var items = {
                        dialogName: 'Check List change: ',
                        logInfo: data.dataUpdated,
                        admin: _this.admin
                    };
                    _this.Dialog.updateValidForm(event, items, 'detail-cl-single-log.html').then(function (dResult) {
                    });
                }
                else {
                    _this.notify.error(data.msg);
                }
            }
            else {
                _this.dataLoaded = true;
                if (angular.isDefined(data) && angular.isDefined(data.dataUpdated)) {
                    _this.table.dataNames = _this.adjustColumnNamesLayout(data.dataUpdated.all_column_order);
                    _this.table.dataOrder = data.dataUpdated.all_column_order;
                }
            }
        });
    }
    /**
      adjustColumnNamesLayout - Transforms the column names object into more user friendly form
      @param {number} original:         original object from the cloudant document
      return  newColumnLayout           user friendly modified object to display column layout
    */
    ColumnsViewController.prototype.adjustColumnNamesLayout = function (original) {
        var displayColumnLayout = [];
        var newColumnLayout;
        var oldColumnLayout = angular.copy(original);
        var correction;
        for (var i = 0; i < original.length; i++) {
            correction = 0;
            if (angular.isDefined(original[i])) {
                newColumnLayout = { current: '', ds: [], versions: [] };
                if (angular.isDefined(original[i].current)) {
                    newColumnLayout.current = original[i].current;
                    delete oldColumnLayout[i].current;
                    correction++;
                }
                if (angular.isArray(original[i].ds)) {
                    newColumnLayout.ds = original[i].ds;
                    delete oldColumnLayout[i].ds;
                    correction++;
                }
                for (var prop in oldColumnLayout[i]) {
                    newColumnLayout.versions.push({
                        versionName: prop,
                        columnLayout: oldColumnLayout[i][prop]
                    });
                }
                ;
                if (newColumnLayout.versions.length === 0) {
                    newColumnLayout.versions.push({
                        versionName: '',
                        columnLayout: { main: [], second: [] }
                    });
                }
            }
            if (correction > 1) {
                displayColumnLayout.push(newColumnLayout);
            }
        }
        ;
        return displayColumnLayout;
    };
    /**
      editMode - Opens the edit checklist view
      @param {number} index:            ID in the array of checklists
      @param {string} program:          program of the to be modified questions
    */
    ColumnsViewController.prototype.editMode = function (index, program) {
        this.$state.go('admin.checklist', { id: index, program: program });
    };
    /**
      viewLogs - Will display the logs of the specified program, only in a limited height
      @param {string} program:        programs name
      @param {boolean} visible:       hides or shows the logs
    */
    ColumnsViewController.prototype.viewLogs = function (program, visible) {
        var preLoaded = false;
        angular.forEach(this.table.data, function (tableItem) {
            if (tableItem.program === program) {
                tableItem.visible = visible;
                if (angular.isUndefined(tableItem.logsData)) {
                    preLoaded = true;
                }
            }
        });
        if (visible && preLoaded) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getAdminLogs',
                    script: '/admin/admin',
                    data: {
                        token: this.env.user.token,
                        adminComponent: 'columns',
                        program: program
                    },
                    token: this.env.user.token
                }
            });
        }
    };
    /**
      showSingleLog - Opens a dialog with the checklist questions, that were logged
      @param {string} path:   name of the cloudant document stripped of the single logs unique name parts
    */
    ColumnsViewController.prototype.showSingleLog = function (path) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getAdminSingleLog',
                script: '/admin/admin',
                data: {
                    token: this.env.user.token,
                    adminComponent: 'columns',
                    path: path
                },
                token: this.env.user.token
            }
        });
    };
    ColumnsViewController.prototype.$onInit = function () {
        var array = new Uint32Array(2);
        this.browserID = window.crypto.getRandomValues(array)[0];
        if (angular.isDefined(this.admin.config)) {
            this.admin.getGeneralConfig();
        }
        ;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getAdminData',
                script: '/admin/admin',
                data: {
                    token: this.env.user.token,
                    adminComponent: 'columns'
                },
                token: this.env.user.token
            }
        });
    };
    /**
      createNew - Creates a new checklist object in edit mode to be added
    */
    ColumnsViewController.prototype.createNew = function () {
        this.$state.go('admin.checklist', { id: 'new', program: 'new' });
    };
    ColumnsViewController.prototype.showColumns = function (line, type) {
        var varName = 'visible' + type;
        line[varName] = (angular.isDefined(line[varName]) && !line[varName]) ? true : false;
    };
    ColumnsViewController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'admin', 'Dialog', 'notify', 'settings'];
    return ColumnsViewController;
}());
var ColumnsViewComponent = (function () {
    function ColumnsViewComponent() {
        this.templateUrl = 'columns-view.html';
        this.controllerAs = 'vm';
        this.controller = ColumnsViewController;
    }
    return ColumnsViewComponent;
}());
angular
    .module('application')
    .component('viewColumnsSection', new ColumnsViewComponent());

//# sourceMappingURL=columns.view.component.js.map
